// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"cb9e6a373092f168","931":"cb58b7865ed06cb5"}[chunkId] + ".css";
};